import { ILocation } from 'src/types/graphql'
import { isBrokerVariant } from 'src/utils/pricing'

/** Price, promotion and href must describe defaultConfiguration together.
 * A stale ISR summary must never replace its price with another unit's price.
 */
export function getCardPrice(location: ILocation) {
  const config = location.defaultConfiguration
  const isBrokerMode = isBrokerVariant(config)
  const area = (config?.size?.width ?? 0) * (config?.size?.length ?? 0)
  const amount = config?.price ?? 0
  const price = isBrokerMode ? (area > 0 ? amount / area : 0) : amount
  const summary = location.configSummary
  const lowest = isBrokerMode
    ? summary?.cheapestPerSqmSizeM2 && summary.cheapestPerSqmSizeM2 > 0
      ? (summary.cheapestPerSqmPrice ?? 0) / summary.cheapestPerSqmSizeM2
      : null
    : summary?.cheapestPrice
  const showFromPrice =
    (summary?.activeCount ?? 0) > 1 &&
    price > 0 &&
    lowest != null &&
    Math.abs(price - lowest) < 0.000001
  return { price, isBrokerMode, showFromPrice }
}
